import { render, staticRenderFns } from "./cardList1.vue?vue&type=template&id=67fd6cbe&scoped=true"
import script from "./cardList1.vue?vue&type=script&lang=js"
export * from "./cardList1.vue?vue&type=script&lang=js"
import style0 from "./cardList1.vue?vue&type=style&index=0&id=67fd6cbe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fd6cbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67fd6cbe')) {
      api.createRecord('67fd6cbe', component.options)
    } else {
      api.reload('67fd6cbe', component.options)
    }
    module.hot.accept("./cardList1.vue?vue&type=template&id=67fd6cbe&scoped=true", function () {
      api.rerender('67fd6cbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/cockpit/components/warning/cardList1.vue"
export default component.exports